<template>
    <restaurant-detail
        class="restaurant-address"
        title="address"
    >
        <address v-test:address>
            {{ address }}
        </address>
    </restaurant-detail>
</template>

<script>
    import RestaurantDetail from '../../molecules/RestaurantDetail/RestaurantDetail';

    export default {
        name: 'restaurant-address',

        components: { RestaurantDetail },

        props: {
            address: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    address {
        margin: 0;
    }
</style>
